// extracted by mini-css-extract-plugin
export default {"compareButton":"CompareButton_compareButton__YE0x5","premium":"CompareButton_premium__Yb0ut","ultimate":"CompareButton_ultimate__Ih-JN"};